/*eslint-disable */
import { AxiosInstance } from 'axios'
import { getCookie } from 'cookies-next'
import { IRequestConfig, IRequestOptions } from '@/shared/services/index'

// Add options interface
interface ServiceOptions {
  axios?: AxiosInstance
}

// Add default options
export const serviceOptionsVoical: ServiceOptions = {}

// Instance selector
function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptionsVoical.axios) {
    return serviceOptionsVoical.axios
      .request(configs)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  } else {
    throw new Error('please inject yourself instance like axios  ')
  }
}

function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url }
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType,
    Authorization: getCookie('access-token') ? 'Bearer ' + getCookie('access-token') : ''
  }
  return configs
}

const basePath = ''

export class ScenarioService {
  /**
   *
   */
  static getScenarioInfo(
    params: {
      /**  */
      scenarioId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static updateScenario(
    params: {
      /**  */
      scenarioId: string
      /** requestBody */
      body?: {
        name: string
        bot_name: string
        bot_style_id: string
        category_id: string
        prompt: string
        voice_id: string
        voice_speed: number
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static deleteScenario(
    params: {
      /**  */
      scenarioId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static updateScenarioAction(
    params: {
      /**  */
      scenarioId: string
      /**  */
      scenarioActionId: string
      /** requestBody */
      body?: UpdateScenarioActionRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}/action/{scenarioActionId}'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')
      url = url.replace('{scenarioActionId}', params['scenarioActionId'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static deleteScenarioAction(
    params: {
      /**  */
      scenarioId: string
      /**  */
      scenarioActionId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}/action/{scenarioActionId}'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')
      url = url.replace('{scenarioActionId}', params['scenarioActionId'] + '')

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static getListScenario(
    params: {
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createScenario(
    params: {
      /** requestBody */
      body?: CreateScenarioRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createScenarioAction(
    params: {
      /**  */
      scenarioId: string
      /** requestBody */
      body?: CreateScenarioActionRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/{scenarioId}/action'
      url = url.replace('{scenarioId}', params['scenarioId'] + '')

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static searchScenario(
    params: {
      /** Từ khóa tìm kiếm */
      keyword?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/outbound'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { keyword: params['keyword'], page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Verify scenario name
   */
  static verifyScenarioName(
    params: {
      /** Tên kịch bản */
      name: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/name/verify'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)
      configs.params = { name: params['name'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Get scenario config
   */
  static getScenarioConfig(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/config'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   * Generate scenario prompt
   */
  static generateScenarioPrompt(
    params: {
      /** requestBody */
      body?: {
        category_id: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/prompt'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   * Test scenario
   */
  static testScenario(
    params: {
      /** requestBody */
      body?: {
        name: string
        bot_name: string
        bot_style_id: string
        category_id: string
        prompt: string
        voice_id: string
        voice_speed: number
        phone_number: string
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario/test'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   * Create scenario
   */
  static createScenarioExternal(
    params: {
      /** requestBody */
      body?: {
        name: string
        bot_name: string
        bot_style_id: string
        category_id: string
        prompt: string
        voice_id: string
        voice_speed: number
      }
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/scenario'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class CampaignService {
  /**
   *
   */
  static getListCampaign(
    params: {
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createCampaign(
    params: {
      /** requestBody */
      body?: CreateCampaignRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static deleteCampaign(
    params: {
      /**  */
      campaignId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  /**
   *
   */
  static updateCampaignInfo(
    params: {
      /**  */
      campaignId: string
      /** requestBody */
      body?: CreateCampaignRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static getCampaignInfo(
    params: {
      /**  */
      campaignId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */

  static getCampaignCustomerInfo(
    params: {
      /**  */
      campaignId: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}/customer'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  static runCampaign(
    params: {
      /**  */
      campaignId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}/run'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */

  /**
   *
   */
  static stopCampaign(
    params: {
      /**  */
      campaignId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}/stop'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static copyCampaign(
    params: {
      /**  */
      campaignId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/{campaignId}/copy'
      url = url.replace('{campaignId}', params['campaignId'] + '')

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  /**
   *
   */
  static searchCampaign(
    params: {
      /** Từ tìm kiếm */
      keyword?: string
      /** Trạng thái */
      status?: string
      /** Id kịch bản */
      scenarioId?: string
      /** Từ ngày */
      fromDate?: number
      /** Đến ngày */
      toDate?: number
      /** Id giọng nói */
      voiceId?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/campaign/search'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = {
        keyword: params['keyword'],
        status: params['status'],
        scenario_id: params['scenarioId'],
        from_date: params['fromDate'],
        to_date: params['toDate'],
        voice_id: params['voiceId'],
        page: params['page'],
        size: params['size']
      }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class AgentService {
  /**
   *
   */
  static getListAgent(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/agent'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class VoiceService {
  /**
   *
   */
  static getListVoice(
    params: {
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/voice'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class CustomerService {
  /**
   *
   */
  static getCustomerInfo(
    params: {
      /**  */
      customerId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}'
      url = url.replace('{customerId}', params['customerId'] + '')

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static updateCustomerInfo(
    params: {
      /**  */
      customerId: string
      /** requestBody */
      body?: UpdateCustomerRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}'
      url = url.replace('{customerId}', params['customerId'] + '')

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static deleteCustomerInfo(
    params: {
      /**  */
      customerId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/{customerId}'
      url = url.replace('{customerId}', params['customerId'] + '')

      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static getListCustomerInfo(
    params: {
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
      /** Từ khóa */
      keyword?: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/search'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { page: params['page'], size: params['size'], keyword: params['keyword'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createCustomer(
    params: {
      /** requestBody */
      body?: CreateCustomerRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createListCustomerByFile(
    params: {
      /**  */
      file: any
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/upload'

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options)

      let data = new FormData()
      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any)
          }
        } else {
          data.append('file', params['file'] as any)
        }
      }

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static getListCustomerInfo1(
    params: {
      /** Từ khóa */
      keyword?: string
      /** Trang */
      page?: number
      /** Số lượng */
      size?: number
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/search'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { keyword: params['keyword'], page: params['page'], size: params['size'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static exportFileData(
    params: {
      /**  */
      file: any
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/upload'

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options)

      let data = null
      data = new FormData()
      if (params['file']) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any)
          }
        } else {
          data.append('file', params['file'] as any)
        }
      }

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static createListCustomer(
    params: {
      /** requestBody */
      body?: CreateCustomerRequest[]
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/customer/list'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class ProviderService {
  /**
   *
   */
  static getListProvider(
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/trunk'
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   *
   */
  static createProvider(
    params: {
      /** requestBody */
      body?: CreateProviderRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/trunk'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /** */
  static getProviderDetail(
    params: {
      sipTrunkId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/trunk/{sipTrunkId}'
      url = url.replace('{sipTrunkId}', params['sipTrunkId'] + '');
      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static editProvider(
    params: {
      sipTrunkId?: string,
      /** requestBody */
      body?: CreateProviderRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/trunk/{sipTrunkId}'
      url = url.replace('{sipTrunkId}', params['sipTrunkId'] + '');

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  static deleteProvider(
    params: {
      sipTrunkId: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/provider/trunk/{sipTrunkId}'
      url = url.replace('{sipTrunkId}', params['sipTrunkId'] + '');
      const configs: IRequestConfig = getConfigs('delete', 'application/json', url, options)

      let data = null
      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class AccountService {
  /**
   *
   */
  static getAccountInfo(options: IRequestOptions = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)

      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static updateAccountInfo(
    params: {
      /** requestBody */
      body?: UpdateAccountRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account'

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static updatePassword(
    params: {
      /** requestBody */
      body?: UpdatePasswordRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/password'

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
  /**
   *
   */
  static activeAccount(
    params: {
      /** requestBody */
      body?: ActiveAccountRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/active'

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }

  /**
   *
   */
  static updatePasswordForget(
    params: {
      /** requestBody */
      body?: UpdatePasswordForgetRequest
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/account/password/forget'

      const configs: IRequestConfig = getConfigs('put', 'application/json', url, options)

      let data = params.body

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export class OtpService {
  /**
   *
   */
  static getOtpDefindByMail(
    params: {
      /** Service code. (signup: service đăng kí) */
      serviceCode: string
      /** Email nhận otp */
      email: string
      /** Loại otp. (1: Đăng kí; 2: Reset password) */
      type: string
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/otp'

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options)
      configs.params = { service_code: params['serviceCode'], email: params['email'], type: params['type'] }
      let data = null

      configs.data = data
      axios(configs, resolve, reject)
    })
  }
}

export interface UpdatePasswordForgetRequest {
  /** Email */
  email: string

  /** Mật khẩu */
  password: string

  /** Xác nhận mật khẩu */
  confirm_password: string

  /** OTP */
  otp: string
}

export interface ActiveAccountRequest {
  /** Email */
  email: string

  /** OTP */
  otp: string
}

export interface CreateProviderRequest {
  /** name */
  name: string

  /** address */
  address: string

  /** phone_numbers */
  phone_numbers: string[]

  /** username */
  username: string

  /** password */
  password: string
}

export interface UpdatePasswordRequest {
  /** Email */
  email: string

  /** Mật khẩu */
  password: string

  /** Xác nhận mật khẩu */
  confirm_password: string

  /** OTP */
  otp: string
}

export interface UpdateAccountRequest {
  /** Họ */
  last_name?: string

  /** Tên */
  first_name?: string

  /** Số điện thoại */
  phone_number?: string
}

export interface UpdateCustomerRequest {
  /** Tên khách hàng */
  name?: string

  /** Email khách hàng */
  email?: string

  /** Giới tính (1: Nam, 2: Nữ) */
  sex?: number

  /** Địa chỉ */
  address?: string

  phone_number: string
}

export interface CreateCustomerRequest {
  /** Tên khách hàng */
  name?: string

  /** Email khách hàng */
  email?: string

  /** Số điện thoại khách hàng */
  phone_number: string

  /** Giới tính (1: Nam, 2: Nữ) */
  sex?: number

  /** Địa chỉ */
  address?: string
}

export interface CreateCampaignRequest {
  id?: string
  stt?: string
  /** Tên chiến dịch */
  name?: string

  /** Id kịch bản */
  scenario?: any

  scenario_id?: string

  agent?: any
  agent_id?: string

  /** Id giọng đọc */
  voice_id: string
  voice?: any

  /** Tốc độ đọc */
  voice_speed?: number

  /** Danh sách id người dùng */
  customer_ids?: string[]

  customer?: any

  /** Ngày bắt đầu */
  start_date?: number

  /** Ngày kết thúc */
  end_date?: number

  /** Khung giờ */
  time_frames?: TimeFrame[]

  /** Thời lượng tối đa (s) */
  max_call_duration?: number

  /** Số cuộc gọi đồng thời */
  parallel_call_count?: number

  /** Điều kiện gọi lại (1: Khi máy bận; 2: Vào thư thoại; 3: Không nghe máy; 4: Không gọi được) */
  recall_condition?: any

  /** Số lần gọi lại */
  retry_count?: number

  /** Thời gian chờ gọi lại */
  retry_delay_time?: number

  /** Nhóm người dùng(1: Nhóm đầu số hệ thống; 2: Nhóm đầu số cá nhân) */
  group?: string
  /** Cấu hình tin nhắn sau cuộc gọi */
  message_after_call_config?: {
    /** Bật/tắt tính năng gửi tin nhắn sau cuộc gọi */
    enable?: boolean
    /** ID ứng dụng Zalo */
    zalo_app_id?: string
    /** Secret key của ứng dụng Zalo */
    zalo_app_secret?: string
    /** Mã xác thực */
    code_verifier?: string
    /** Token làm mới */
    refresh_token?: string
    /** ID template tin nhắn */
    template_id?: string
    /** Đối tượng nhận tin nhắn (0: Tất cả, 1: Quan tâm, 2: Không quan tâm) */
    target?: number
  }
}

export interface TimeFrame {
  start_time?: string
  start_time_date?: Date
  end_time?: string
  end_time_date?: Date
}

type ICreateCampaignRequestRecallCondition = any

export interface CampaignDetailDTO {
  /** Id chiến dịch */
  id?: string

  /** Tên chiến dịch */
  name?: string

  /** Trạng thái */
  status?: number

  /** Tên kịch bản */
  scenario_name?: string

  /** Tên giọng nói */
  voice_name?: string

  /** Thông tin danh sách khách hàng */
  customers?: CustomerDTO[]

  /** Ngày bắt đầu */
  start_date?: number

  /** Ngày kết thúc */
  end_date?: number

  /** Khung giờ */
  time_frames?: TimeFrame[]

  /** Thời lượng tối đa (s) */
  max_call_duration?: number

  /** Số cuộc gọi đồng thời */
  parallel_call_count?: number

  /** Điều kiện gọi lại (1: Khi máy bận; 2: Vào thư thoại; 3: Không nghe máy; 4: Không gọi được) */
  recall_condition?: any

  /** Số lần gọi lại */
  retry_count?: number

  /** Thời gian chờ gọi lại */
  retry_delay_time?: number
}

export interface CampaignDTO {
  /** Id chiến dịch */
  id?: string

  /** Tên chiến dịch */
  name?: string

  /** Trạng thái */
  status?: number

  /** Tiến độ */
  progress?: number

  /** Tên kịch bản */
  scenario_name?: string

  /** Tên giọng nói */
  voice_name?: string

  /** Ngày bắt đầu */
  start_date?: number

  /** Ngày kết thúc */
  end_date?: number

  /** Tổng số khách hàng */
  customer_count?: number

  /** Số khách hàng chưa gọi */
  customer_not_call_count?: number

  /** Số khách hàng chờ gọi */
  customer_wait_call_count?: number

  /** Số lượng cuộc gọi (s) */
  call_count?: number
}

export interface PageDTOCampaignDTO {
  /**  */
  list?: CampaignDTO[]

  /**  */
  page?: number

  /**  */
  size?: number

  /**  */
  total?: number
}
export interface CustomerDTO {
  /** Id khách hàng */
  id?: string

  /** Tên khách hàng */
  name?: string

  /** Email khách hàng */
  email?: string

  /** Số điện thoại khách hàng */
  phone_number?: string

  /** Giới tính (1: Nam, 2: Nữ) */
  sex?: number

  /** Địa chỉ */
  address?: string

  /** Id tổ chức */
  organization_id?: string
}

export interface RCampaignDetailDTO {
  /**  */
  code?: number

  /**  */
  msg?: string

  /**  */
  data?: CampaignDetailDTO

  /**  */
  ts?: number
}

export interface CreateScenarioActionRequest {
  /** Tên kịch bản hoạt động */
  name?: string

  /** Giới hạn thời gian phản hồi (s) */
  limit_response_time?: number

  /** Bàn phím người dùng */
  keypad?: string

  /** Từ khóa */
  keyword?: string

  /** Lời thoại */
  speech_text?: string

  /**  */
  speech_invalid_text?: string

  /** Id hành động phía trước */
  parent_action_id?: string
}

export interface CreateScenarioRequest {
  /** Tên kịch bản */
  name?: string

  /** Link ảnh kịch bản */
  image_url?: string

  /** Câu nói khi bắt đầu hội thoại */
  start_conversion?: string
}

export interface UpdateScenarioActionRequest {
  /** Tên kịch bản hoạt động */
  name?: string

  /** Giới hạn thời gian phản hồi (s) */
  limit_response_time?: number

  /** Bàn phím người dùng */
  keypad?: string

  /** Từ khóa */
  keyword?: string

  /** Lời thoại */
  speech_text?: string

  /**  */
  speech_invalid_text?: string

  /** Id hành động phía trước */
  parent_action_id?: string
}

export interface UpdateScenarioRequest {
  /** Tên kịch bản */
  name?: string

  /** Link ảnh kịch bản */
  image_url?: string

  /** Bắt đầu cuộc gọi */
  start_conversion?: string
}
